module.exports = __webpack_public_path__ + "img/ISO27001.90f6638b.png";